/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Stack, Text } from '@fluentui/react';
import RunExpectationsRecommendation from './RunExpectations';
import ContractNotApprovedRecommendation from './ContractNotApproved';
import ProductSeedingRecommendation from './ProductSeeding';
import ContractIngestionListRecommendation from './ContractIngestionList';
import ContractReIngestionRecommendation, {
  shouldShowContractReIngestionRecommendation,
  getTotalIngestedQuantity,
} from './ContractReIngestion';
import ProductReIngestionRecommendation, {
  shouldShowProductReIngestionRecommendation,
} from './ProductReIngestion';
import CleanupStagedTxsRecommendation from './CleanupStagedTxs';

export default function DebugRecommendations({ data }) {
  const recommendations = useMemo(() => {
    const {
      expectationsBreakdown,
      stagedTransactionsBreakdown,
      contract,
      isInContractIngestionList,
    } = data;
    const recommendationsList = [];

    const isContractApproved = contract.approvalStatus.toLowerCase() === 'approved';

    if (
      !isEmpty(stagedTransactionsBreakdown.totalsByErrorReason.ContractNotApproved) ||
      !isContractApproved
    ) {
      recommendationsList.push(<ContractNotApprovedRecommendation data={data} />);
    }

    if (!isInContractIngestionList) {
      recommendationsList.push(<ContractIngestionListRecommendation data={data} />);
    }

    if (expectationsBreakdown.totalQuantity === 0) {
      recommendationsList.push(<RunExpectationsRecommendation data={data} />);
    }

    if (isContractApproved) {
      if (shouldShowContractReIngestionRecommendation(data)) {
        recommendationsList.push(<ContractReIngestionRecommendation data={data} />);
      } else if (shouldShowProductReIngestionRecommendation(data)) {
        recommendationsList.push(<ProductReIngestionRecommendation data={data} />);
      } else if (getTotalIngestedQuantity(data) < expectationsBreakdown.totalQuantity) {
        recommendationsList.push(
          <ContractReIngestionRecommendation
            data={data}
            message="We have not ingested all the transactions for this month. There are several reasons why this can happen. To fix this, just follow the steps below."
          />,
        );
      }
    }

    if (!isEmpty(stagedTransactionsBreakdown.totalsByErrorReason.ProductLookupFailed)) {
      recommendationsList.push(<ProductSeedingRecommendation data={data} />);
    }

    if (!isEmpty(stagedTransactionsBreakdown.ingestedIds)) {
      recommendationsList.push(<CleanupStagedTxsRecommendation data={data} />);
    }

    return recommendationsList;
  }, [data]);

  if (recommendations.length === 0) {
    return null;
  }

  return (
    <Stack tokens={{ childrenGap: 14 }}>
      <Text style={{ fontWeight: 'bold' }}>Recommendations</Text>
      {recommendations}
    </Stack>
  );
}

DebugRecommendations.propTypes = {
  data: PropTypes.shape({}).isRequired,
};
